const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const motionQuery = window.matchMedia('(prefers-reduced-motion: no-preference)');

const revealSelectors = [
  '.cdw-values__grid',
  '.cdw-categories__header',
  '.cdw-category',
  '.cdw-lines__header',
  '.cdw-line-card',
  '.cdw-lines__footer',
  '.cdw-finish-studio__header',
  '.cdw-finish-card',
  '.cdw-design__media',
  '.cdw-design__content',
  '.cdw-faq__header',
  '.cdw-faq__grid',
];

let observer;

function revealImmediately(element) {
  element.classList.add('cdw-motion-visible');
}

function prepareMotion(root = document) {
  if (reducedMotion.matches || !observer) return;

  const elements = [...root.querySelectorAll(revealSelectors.join(','))].filter(
    (element) => !element.hasAttribute('data-cdw-motion-ready')
  );

  elements.forEach((element) => {
    element.setAttribute('data-cdw-motion-ready', '');

    const group = element.parentElement;
    if (group) {
      const siblings = [...group.children].filter((child) => child.matches?.(revealSelectors.join(',')));
      const index = siblings.indexOf(element);
      element.style.setProperty('--cdw-motion-delay', `${Math.min(Math.max(index, 0), 5) * 65}ms`);
    }

    const bounds = element.getBoundingClientRect();
    if (bounds.top < window.innerHeight * 0.88 && bounds.bottom > 0) {
      revealImmediately(element);
    } else {
      observer.observe(element);
    }
  });
}

function startMotion() {
  if (reducedMotion.matches || !motionQuery.matches || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('cdw-motion-ready');
  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        revealImmediately(entry.target);
        observer.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -9% 0px', threshold: 0.08 }
  );

  prepareMotion();
}

startMotion();

document.addEventListener('shopify:section:load', (event) => {
  prepareMotion(event.target);
});
